import React, { Component } from 'react';
import Table from '../components/indicators/IndicatorTable/Show'
import WebpackerReact from 'webpacker-react';

class IndicatorTableShow extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    loadData = () => {
        fetch(`/indicator/get_indicator_tables_show/${this.props.indicator.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    isLoaded={this.state.isLoaded}
                    indicator={this.props.indicator}
                />
            </React.Fragment>
        );
    }
}


export default IndicatorTableShow;
WebpackerReact.setup({ IndicatorTableShow });
